import axios from "axios";
import * as Sentry from "@sentry/react";
import { trackEvent } from "./analytics";

const axiosInstance = axios.create({
    baseURL: "",
    headers: {
        "Content-Type": "application/json"
    }
});

axiosInstance.interceptors.request.use((config) => {
    config.metadata = { startTime: performance.now() };

    const token = localStorage.getItem("auth_token");
    const deviceId = localStorage.getItem("device_id");
    if (token) config.headers["auth_token"] = token;
    if (deviceId) config.headers["device_id"] = deviceId;

    return config;
});

axiosInstance.interceptors.response.use(
    (response) => {
        const latency = performance.now() - response.config.metadata.startTime;
        const url = response.config.url;

        console.log(`[Axios] ${url} took ${latency} ms`);

        trackEvent({
            category: "API Latency",
            action: url,
            label: `Latency: ${latency} ms`,
            value: Math.round(latency)
        });

        Sentry.addBreadcrumb({
            category: "api",
            message: `${url} took ${latency} ms`,
            level: "info"
        });

        return response;
    },
    (error) => {
        const latency = performance.now() - error.config?.metadata?.startTime;
        const url = error.config?.url ?? "unknown";

        console.warn(`[Axios Error] ${url} failed after ${latency} ms`);

        trackEvent({
            category: "API Error",
            action: url,
            label: `Failed after ${latency} ms`,
            value: Math.round(latency)
        });

        Sentry.captureException(error, {
            tags: { api: url },
            extra: { latency }
        });

        return Promise.reject(error);
    }
);

export default axiosInstance;
